import { Component, Input, QueryList, ViewChildren } from '@angular/core';

import { BaseFormList, ConfigService, MessageService } from '../../../core';
import { UnidadeNegocioMercado } from './unidade-negocio-mercado';
import { Mercado, mercadoAtivo, MercadoNomePipe, MercadoTypeaheadComponent } from '../../mercado';

@Component({
    selector: 'sgt-unidade-negocio-mercado',
    templateUrl: './unidade-negocio-mercado.component.html',
    styleUrls: ['./unidade-negocio-mercado.component.less']
})
export class UnidadeNegocioMercadoComponent implements BaseFormList<UnidadeNegocioMercado> {
    @Input() entities: UnidadeNegocioMercado[];

    // Mercados
    mercadoSituacaoAtivo = mercadoAtivo.id;
    @ViewChildren('mercadoTypeahead') mercadosTypeaheads: QueryList<MercadoTypeaheadComponent>;

    constructor(private configService: ConfigService,
                private messageService: MessageService,
                private mercadoNomePipe: MercadoNomePipe) { }

    /** Ao alterar o mercado */
    onChangeMercado(entity: UnidadeNegocioMercado, mercado: Mercado) {
        if (!entity) {
            return;
        }

        entity.idMercado = mercado?.id ?? null;
    }

    insert() {
        const entity = new UnidadeNegocioMercado();
        this.entities.push(entity);

        setTimeout(() => this.mercadosTypeaheads?.last?.setFocus(), 200);
    }

    delete(index: number) {
        if (index <= -1) {
            return;
        }
        const entity = this.entities[index];
        this.messageService.confirm(`Deseja realmente excluir o mercado ${this.mercadoNomePipe.transform(entity?.mercado?.nome, entity?.mercado?.codigoIntegracaoErp)} da unidade de negócio?`).then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Verifica se os mercados estão válidos */
    isValid(): boolean {
        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];
            if (!entity.idMercado) {
                continue;
            }
            const count = this.entities.filter(entityFilter => entityFilter.idMercado && entityFilter.idMercado === entity.idMercado).length;
            if (count > 1) {
                this.messageService.info(`O mercado ${this.mercadoNomePipe.transform(entity?.mercado?.nome, entity?.mercado?.codigoIntegracaoErp)} já está adicionado na unidade de negócio. Remova ou altere o mercado duplicado`, 'Não é possível adicionar dois mercados iguais na mesma unidade de negócio');
                return false;
            }
        }
        return true;
    }


    /** Resolve os mercados presentes na Unidade de Negócio */
    resolve() {
        if (!this.entities) {
            return;
        }

        // Removendo os itens do array que não possuirem o ID do mercado informado
        for (let i = this.entities.length; i--; ) {
            const entity = this.entities[i];
            if (!entity.idMercado) {
                this.entities.splice(i, 1);
            }
        }
    }

}
